import React from 'react';
import { LayoutDashboard, Star, Shield, LogOut } from 'lucide-react';
import { User } from '../../../types';
interface ProfileDropdownProps {
  user: User | null;
  t: (key: string) => string;
  handleNavClick: (page: string) => void;
  logout: () => void;
}
export function ProfileDropdown({
  user,
  t,
  handleNavClick,
  logout
}: ProfileDropdownProps) {
  return <div className="absolute top-full right-0 mt-1.5 w-52 rounded-xl shadow-xl bg-white ring-1 ring-slate-900/5 z-50 overflow-hidden" data-id="element-16522">
      <div className="px-3 pt-3 pb-2 border-b border-slate-100" data-id="element-16523">
        <div className="text-sm font-bold text-slate-900 truncate" data-id="element-16524">
          {user?.name}
        </div>
        <div className="text-xs text-slate-500 truncate" data-id="element-16525">{user?.email}</div>
      </div>
      <div className="p-1.5" data-id="element-16526">
        <button onClick={() => handleNavClick(user?.role === 'astrologer' ? 'dashboard-astrologer' : 'dashboard-user')} className="flex items-center gap-2.5 w-full text-left px-3 py-2 rounded-lg text-sm font-medium text-slate-700 hover:bg-slate-50 hover:text-indigo-600 transition-colors" data-id="element-16527">
          <LayoutDashboard className="w-4 h-4 text-slate-400" data-id="element-16528" />
          {t('profile.dashboard')}
        </button>
        {user?.role === 'astrologer' && <button onClick={() => handleNavClick('dashboard-astrologer')} className="flex items-center gap-2.5 w-full text-left px-3 py-2 rounded-lg text-sm font-medium text-slate-700 hover:bg-slate-50 hover:text-indigo-600 transition-colors" data-id="element-16529">
            <Star className="w-4 h-4 text-amber-500" data-id="element-16530" />
            {t('profile.astrologer')}
          </button>}
        {user?.role === 'admin' && <button onClick={() => handleNavClick('admin')} className="flex items-center gap-2.5 w-full text-left px-3 py-2 rounded-lg text-sm font-medium text-slate-700 hover:bg-slate-50 hover:text-indigo-600 transition-colors" data-id="element-16531">
            <Shield className="w-4 h-4 text-rose-500" data-id="element-16532" />
            Админ-панель
          </button>}
        <div className="h-px bg-slate-100 my-1" data-id="element-16533"></div>
        <button onClick={() => {
        logout();
        handleNavClick('home');
      }} className="flex items-center gap-2.5 w-full text-left px-3 py-2 rounded-lg text-sm font-medium text-rose-600 hover:bg-rose-50 transition-colors" data-id="element-16534">
          <LogOut className="w-4 h-4 text-rose-400" data-id="element-16535" />
          {t('profile.logout')}
        </button>
      </div>
    </div>;
}